import { FatoSolicitacaoOci } from 'graphql/types.generated'

import { SolicitacaoOciModel } from './model-oci'

export const convertFatoSolicitacaoOciToSolicitacaoOciModel = (
  fatoSolicitacoesOci: FatoSolicitacaoOci[]
): SolicitacaoOciModel[] => {
  return fatoSolicitacoesOci?.map((fatoSolicitacaoOci) => ({
    id: fatoSolicitacaoOci.id,
    procedimentos: [
      {
        procedimento: {
          id: fatoSolicitacaoOci.dimensaoProcedimento.id,
          codigo: fatoSolicitacaoOci.dimensaoProcedimento.codigoProcedimento,
          descricao: fatoSolicitacaoOci.dimensaoProcedimento.descricaoProcedimento,
        },
      },
    ],
  }))
}
